<template>
  <div class="authority-manage rhBrand-box position-header">
    <navHeader :titleList="['系统管理', '区域管理']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            row-key="id"
            class="flex-1" stripe height="100%"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="名称">
            </el-table-column>
            <el-table-column prop="level" align="center" label="层级">
            </el-table-column>
            <el-table-column prop="parentId" align="center" show-overflow-tooltip label="父编号">
            </el-table-column>
            <el-table-column prop="remark" align="center" show-overflow-tooltip label="备注">
            </el-table-column>
          </el-table>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      id: '',
      name: '',
      englishName: '',
      status: '',
      statuses: [
        {
          label: '待审核',
          value: '0'
        },
        {
          label: '审核通过',
          value: '1'
        },
        {
          label: '审核驳回',
          value: '2'
        }
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
  },
  mounted () {},
  methods: {
    async getPageList () {
      let { data: res } = await this.$http.get('/cosmeticBrand/cosmeticBrand/getChannelList')
      console.log(res)
      if (res.code === '200') {
        this.tableData = res.data
      }
    },
    reset () {
      this.name = ''
      this.englishName = ''
      this.status = ''
      this.owner = ''
      this.getPageList()
    },
    add () {
      this.$router.push('/rhDetail')
    },
    edit (id) {
      console.log(id)
      this.$router.push({
        name: 'RhDetail',
        params: {
          id,
          type: 'edit'
        }
      })
    },
    deleteMore () {
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    exportAll () {
      this.$confirm(`确认导出选中的${this.selectData.length}条数据?`, '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    verifyMore () {
      this.dialogShow = true
      this.verifySrc = '/cosmeticBrand/cosmeticBrand/examine'
    },
    verify (id, status, statusRemarks) {
      this.dialogShow = true
      this.id = id
      this.verifyForm.status = status
      this.verifyForm.statusRemarks = statusRemarks
    },
    confirm () {
      this.$refs.verifyForm.validate(val => {
        if (val) {
          if (this.verifyForm.status === '1') {
            this.verifyForm.statusRemarks = ''
          }
          let params = JSON.parse(JSON.stringify(this.verifyForm))
          params.id = this.id
          this.$http.post('/cosmeticBrand/cosmeticBrand/examine', params).then(res => {
            if (res.data.code === '200') {
              this.dialogShow = false
              this.getPageList()
              this.$message.success(res.data.msg)
            }
          })
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        statusRemarks: ''
      }
    },
    addProduct (id) {
      this.$router.push({
        name: 'AddProduct',
        params: {
          id
        }
      })
    },
    deleteInfo (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        this.$http.post('/cosmeticBrand/cosmeticBrand/delete', {id}).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败'
          })
        })
      })
    },
    onlinePreview () {
      this.onlineShow = true
    },
    qrPreview () {
      this.previewShow = true
    }
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/systemManagement/area.vue